<template>
  <div class="jd-page--detail">
    <div
      class="jd-detail--cover"
      ref="topCover"
      :style="{ backgroundImage: `url(${bgImg})`, height: `${cHeight}px` }"
    >
      <div class="jd-detail--desc  p-absolute--b">
        <h3 class="ta-center jd-detail--name" v-if="detailAppraiser">
          {{ detailAppraiser.name || '' }}
        </h3>
        <div
          class="jd-tags-box ta-center"
          v-if="detailAppraiser && detailAppraiser.teacherTabs"
        >
          <k-tag
            v-for="(item, index) in detailAppraiser.teacherTabs"
            :key="index"
            round
            color="white"
            text-color="#999"
            >{{ item }}</k-tag
          >
        </div>
        <div class="jd-dtail--desc fts-sm" v-if="detailAppraiser">
          {{ detailAppraiser.des }}
        </div>
      </div>
    </div>
    <div>
      <appraiser-good
        v-if="detailAppraiser"
        :wcount="detailAppraiser.wcount || 0"
        :through="detailAppraiser.through || ''"
        :slow="(detailAppraiser.slow || 0) | fen2yuan"
        :fast="(detailAppraiser.fast || 0) | fen2yuan"
      />
    </div>
    <div class="jd-detail--main" v-if="authenticatedList">
      <k-row v-if="authenticatedList.length">
        <k-col
          v-for="(item, index) in authenticatedList"
          :key="index"
          span="12"
          class="jd-home-prd-item"
        >
          <k-prd-item
            :link="`/jianding/view?orderId=${item.id}`"
            target="_blank"
            :item="item"
            :img="item.pictures | getPic | resize(480, 480)"
            :title="item.definition"
            :periods="cfgPeriods[item.periods]"
            :real="cfgIsReal[item.isReal]"
          />
          <router-link :to="`/view?orderId=${item.id}`"> </router-link>
        </k-col>
      </k-row>
      <div v-else class="k-nodata">暂无数据！</div>
    </div>
    <!--<div class="jd-fixed-btns" v-if="detailAppraiser && detailAppraiser.status === 1">
            <k-button type="primary" v-show="showBtn" @click="step=2" block :to="`/publish?aid=${aid}`">请Ta鉴定</k-button>
        </div>-->
    <template v-if="detailAppraiser && detailAppraiser.status === 1">
      <router-link
        v-show="showBtn"
        @click="step = 2"
        class="jd-home-publish-btn"
        :to="`/publish?aid=${aid}`"
        ><span>请Ta<br />鉴定</span></router-link
      >
    </template>
    <jd-tabbar />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
export default {
  name: 'appraiser-detail',
  data() {
    return {
      aid: +this.$route.query.aid || 0,
      list: null,
      info: null,
      pageNum: 100,
      cHeight: 500,
    }
  },
  computed: {
    ...mapGetters('jianding', ['cfgPeriods', 'cfgIsReal']),
    ...mapGetters('account', ['myUid']),
    ...mapState('jianding', ['detailAppraiser', 'authenticatedList']),
    des() {
      return this.detailAppraiser['des'] || ''
    },
    bgImg() {
      return this.detailAppraiser ? this.detailAppraiser.background : ''
    },
    showBtn() {
      return this.aid != this.myUid ? true : false
    },
  },
  methods: {
    ...mapActions('jianding', ['loadAuthenticatedList', 'loadDetailAppraiser']),
    ...mapMutations('jianding', ['delStateByKey']),
    async load() {
      let { aid, pageNum } = this
      await this.loadAuthenticatedList({
        aid,
        pageNum,
        status: '4,7', //已完成 已评价
      })
    },
    makeShare() {
      let kShare = window.kShare
      if (kShare) {
        kShare.make({
          title: this.detailAppraiser.name,
          image: this.bgImg,
          mpImage: this.bgImg,
          description: this.des,
          url: location.href,
        })
      }
    },
  },
  async created() {
    if (this.detailAppraiser && this.detailAppraiser.aid !== this.aid) {
      this.delStateByKey({ key: 'authenticatedList' })
    }
    if (!this.detailAppraiser || this.detailAppraiser.aid !== this.aid) {
      await this.loadDetailAppraiser({ aid: this.aid })
      await this.load()
      this.makeShare()
    }
  },
  mounted() {
    let coverW = this.$refs.topCover.clientWidth
    this.cHeight = coverW
  },
//   watch: {
//     authenticatedList() {
//       //console.log(nv)
//     },
//   },
  beforeDestroy() {},
}
</script>
